<template>
  <div class="app-checkout-sim-data">
    <div class="sim-data--header"><slot name="txtHeadline">DATA</slot></div>
    <div class="customer-data--form">
      <b-form id="customer-data-form" :novalidate="true">
        <LabeledRadioInput name="simType"
                           class="simType"
                           :model.sync="simData_.simType"
                           :label="getSlotText('lblType')"
                           first-radio-value="SIM_CARD"
                           second-radio-value="E_SIM"
        >
          <template v-slot:afterLabel><button @click="trackAndShowSimTypeInfoModal()" class="icon-only" type="button">
            <img src="/files/flash/images/svg-icons/info-icon.svg" width="16" height="16" alt="info" :aria-label="getSlotText('infoIconAriaLabel')">
          </button></template>
          <template v-for="slot in possibleChildSlotsFor('SimType')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </LabeledRadioInput>
        <div class="info-device-box">
          <button class="device-check-link text-nowrap" @click.prevent="trackAndShowESimCheckInfoModal()" type="button"><slot name="txtESimDeviceCheckLink"></slot></button>
        </div>
        <div class="info-box info-box-eid" v-if="isESimSelected">
          <slot name="txtESimInfoBox"></slot>
          <div class="eid-inserted" v-if="isEIDStored">
            <strong><slot name="txtEidLabel"></slot>: </strong><span>{{simData.eID}}</span>
            <a href="javascript:;" ref="eidCheckButton" @click.prevent="trackAndShowEIDInsertModal()"><slot name="txtEidModalEditLink"></slot></a>
          </div>
          <div class="eid-info-text" v-else>
            <div class="eid-headline"><slot name="txtEidInfoHeadline"></slot><button @click="trackAndShowEIDInfoModal()" class="icon-only" type="button">
              <img src="/files/flash/images/svg-icons/info-icon.svg" width="16" height="16" alt="info" :aria-label="getSlotText('eidInfoIconAriaLabel')">
            </button></div>
            <div class="eid-text">
              <slot name="txtEidInfoText"></slot> <a href="javascript:;" @click.prevent="trackAndShowEIDInsertModal()"><slot name="txtEidModalInsertLink"></slot></a>
            </div>
          </div>
        </div>
        <SimonModal
          :is-visible="showSimTypeInfoModal"
          @hide="showSimTypeInfoModal = false"
          id="sim-type-info-modal"
          size="large"
        >
          <template v-slot:modalTitle>
            <h3><slot name="titleSimTypeInfoModal"></slot></h3>
          </template>
          <b-tabs card pills align="center">
            <b-tab :title="getSlotText('tabSimTypeInfoModalSim')" :active="!isESimSelected">
              <b-card-text><slot name="txtSimTypeInfoModalSim"></slot></b-card-text>
            </b-tab>
            <b-tab :title="getSlotText('tabSimTypeInfoModalESim')" :active="isESimSelected">
              <b-card-text><slot name="txtSimTypeInfoModalESim"></slot></b-card-text>
            </b-tab>
          </b-tabs>
        </SimonModal>
        <SimonModal
          :is-visible="showESimCheckInfoModal"
          @hide="showESimCheckInfoModal = false"
          id="esim-check-info-modal"
          size="large"
          custom-modal-class="esim-check-info-modal"
        >
          <template v-slot:modalTitle><h3><slot name="txtTitleModalDeviceCheck"></slot></h3></template>
          <b-form-group class="custom-input-select">
            <b-form
            :id="'form' + _uid"
            :novalidate="true"
            class="device-check-modal-form"
            ref="form">
            <ESimDevicecheck>
              <template v-for="slot in possibleChildSlotsFor('DeviceCheck')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </ESimDevicecheck>
          </b-form>
          </b-form-group>
        </SimonModal>
        <SimonModal
          :is-visible="showEIDInfoModal"
          @hide="showEIDInfoModal = false"
          id="eid-info-modal"
        >
          <template v-slot:modalTitle><h3><slot name="titleEidInfoModal"></slot></h3></template>
          <p><slot name="txtEidInfoModal"></slot></p>
        </SimonModal>
        <SimonModal
          size="large"
          :is-visible="showEIDInsertModal"
          @hide="showEIDInsertModal = false"
          @hidden="handleHideEIDModal"
          id="eid-insert-modal"
          show-footer-buttons
          @btnLeft="handleHideEIDModal"
          @btnRight="handleEIDOkButton"
          :disabled-btn-right="invalid.insertedEID"
          :btn-left-title="getSlotText('btnPrev', 'Abbrechen')"
          :btn-right-title="getSlotText('btnNext', 'Bestätigen')"
        >
          <template v-slot:modalTitle><h3><slot name="titleEidInsertModal"></slot></h3></template>
          <slot name="txtEidInsertModal"></slot>
          <div class="form-wrapper">
            <b-form
              :id="'form' + _uid"
            >
              <LabeledTextInput
                name="eID"
                id="eID"
                ref="eID"
                :formatter="eIDFormatter()"
                :model.sync="insertedEID"
                :invalid.sync="invalid.insertedEID"
                :validation="validations.insertedEID"
              >
                <template v-for="slot in possibleChildSlotsFor('EID')" v-slot:[`${slot.child}`]>
                  <slot :name="`${slot.parent}`"></slot>
                </template>
              </LabeledTextInput>
            </b-form>
          </div>
        </SimonModal>
      </b-form>
    </div>
    <Ident v-if="isESimSelected"
           :ident.sync='identData.identCard'
           :nationality.sync='identData.nationality'
           :ident-type.sync='identData.identType'
           :process='process'
           :headline='headline'
    >
      <template v-for="slot in possibleChildSlotsFor('IdentData')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Ident>
    <Stepper
      :disabledNext="disableButton"
      :show-prev="true"
      :btnNextAriaLabel="getSlotText('btnNextAriaLabel')"
      @prev="$emit('goBack')"
      @next="save()"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>

import Stepper from '../../generic/Stepper.vue'
import Ident from '../identData/Ident.vue'
import LabeledRadioInput from '../../forms/LabeledRadioInput.vue'
import SimonModal from '../../modal/SimonModal.vue'
import useFeature from '@/mixins/useFeature'
import { BForm } from 'bootstrap-vue'
import ESimDevicecheck from '../simData/ESimDevicecheck.vue'
import validationFlow from '@/mixins/validators/validationFlow'
import { validationMixin } from 'vuelidate'
import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import preFilledObjectInput from '@/mixins/preFilledObjectInput'
import LabeledTextInput from '../../forms/LabeledTextInput.vue'
import isValid from '@/mixins/validators/isValid'
import transaction from '@/mixins/transaction'
import { omit } from 'vue-apollo/lib/utils'
export default {
  name: 'SimData',
  components: {
    LabeledTextInput,
    ESimDevicecheck,
    BForm,
    SimonModal,
    LabeledRadioInput,
    Ident,
    Stepper
  },
  mixins: [
    isValid,
    validationMixin,
    validationFlow,
    transaction('checkout'),
    useFeature('disableEsimWithoutMnp'),
    preFilledObjectInput('simData', 'getSimData'),
    preFilledObjectInput('identData', 'getIdentData')
  ],
  props: {
    process: {
      type: String,
      default: 'ordering'
    }
  },
  data () {
    return {
      headline: 'h3',
      showSimTypeInfoModal: false,
      showESimCheckInfoModal: false,
      showEIDInfoModal: false,
      showEIDInsertModal: false,
      showESimSelectedAsync: false,
      insertedEID: '',
      invalid: {
        insertedEID: null
      },
      validations: {
        simData: {
          simType: {
            required
          }
        },
        insertedEID: {
          minLength: minLength(32),
          maxLength: maxLength(32),
          checksum: (v) => {
            return this.checksum(v)
          }
        }
      }
    }
  },
  mounted () {
    if (this.simData?.eID !== '') {
      this.insertedEID = this.simData.eID
    }
  },
  methods: {
    trackAndShowSimTypeInfoModal () {
      this.showSimTypeInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'sim type info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    trackAndShowESimCheckInfoModal () {
      this.showESimCheckInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'device check info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    trackAndShowEIDInfoModal () {
      this.showEIDInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'fast esim installation info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    trackAndShowEIDInsertModal () {
      this.showEIDInsertModal = true
      const textInformationName = this.isEIDStored ? 'fast esim installation eid change' : 'fast esim installation eid entry'
      const data = {
        information_action: 'reveal',
        information_name: textInformationName,
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    save () {
      if (!this.isESimSelected) {
        this.simData.eID = ''
        this.identData.nationality = {
          frequency: '',
          iso2: '',
          iso3: '',
          name: ''
        }
        this.identData.identCard = {
          key: '',
          name: ''
        }
        this.identData.identType = ''
      }
      this.$store.commit('checkoutv2/' + this.process + '/_simData/setSimData', {
        simType: this.simData.simType,
        eID: this.simData.eID
      })
      this.$store.commit('checkoutv2/' + this.process + '/_identData/setIdentData', {
        nationality: this.identData.nationality,
        identCard: omit(this.identData.identCard, 'identMethods'),
        identType: this.identData.identType
      })
      this.$emit('goForward')
    },
    handleEIDOkButton (event) {
      this.showEIDInsertModal = false
      if (!this.invalid.insertedEID) {
        // put valid eid into the store
        this.simData.eID = this.insertedEID
      } else {
        // Prevent modal from closing
        event.preventDefault()
      }
    },
    handleHideEIDModal () {
      // copy last confirmed eid in tmp variable on modal close
      this.showEIDInsertModal = false
      this.$refs.eidCheckButton.focus()
      // this.insertedEID = this.simData.eID
    },
    eIDFormatter () {
      return (v) => v.replace(/[^\d]/g, '').substring(0, 32)
    },
    modulo (divident, divisor) {
      var partLength = 10
      while (divident.length > partLength) {
        var part = divident.substring(0, partLength)
        divident = (part % divisor) + divident.substring(partLength)
      }
      return divident % divisor
    },
    checksum (value) {
      const stringvalue = '' + value
      if (stringvalue.length === 0) {
        return true // eid is not required here, empty is valid
      } else if (stringvalue.length < this.max32) {
        return false // start check only with 32 letters
      }
      return this.modulo(stringvalue, 97) === 1
    }
  },
  computed: {
    disableButton () {
      if (this.isESimSelected) {
        return !this.identData.identType || this.identData.identCard?.name === ''
      } else {
        return false
      }
    },
    getSimData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_simData/simData']
    },
    getIdentData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_identData/identData']
    },
    isESimSelected: function () {
      return this.simData.simType === 'E_SIM'
    },
    isEIDStored () {
      return this.simData.eID.length > 0
    }
  },
  watch: {
    disableButton (newVal) {
      this.$emit('update-disable', newVal)
    }
  }
}
</script>
